import { QueryClient } from "@tanstack/react-query";
import { type RecordId } from "../ui/tables";

export const createKeys = (base: string) => {
  const all = [base] as const;

  return {
    all,
    list: (params?: unknown) => [...all, "list", params] as const,
    listByRelationId: (params?: unknown) =>
      [...all, "listByRelation", params] as const,
    details: (id: RecordId) => [...all, "details", id] as const,
    counts: (params?: unknown) => [...all, "counts", params] as const,

    invalidateAll: (queryClient: QueryClient) => {
      queryClient.invalidateQueries({ queryKey: all });
    },
    invalidateList: (queryClient: QueryClient, params?: unknown) => {
      queryClient.invalidateQueries({ queryKey: [...all, "list", params] });
    },
    invalidateListByRelationId: (
      queryClient: QueryClient,
      params?: unknown,
    ) => {
      queryClient.invalidateQueries({
        queryKey: [...all, "listByRelation", params],
      });
    },
    invalidateDetails: (queryClient: QueryClient, id: RecordId) => {
      queryClient.invalidateQueries({ queryKey: [...all, "details", id] });
    },
    invalidateCounts: (queryClient: QueryClient, params?: unknown) => {
      queryClient.invalidateQueries({ queryKey: [...all, "counts", params] });
    },
  };
};

// Usage
export const keyValuePairKeys = createKeys("keyValuePairs");
export const ticketKeys = createKeys("tickets");
export const ticketCommentKeys = createKeys("ticketComments");
export const ticketEmailMessageKeys = createKeys("ticketEmailMessages");
export const timelineActivityKeys = createKeys("timelineActivities");
export const emailKeys = createKeys("emails");
export const fileAssetKeys = createKeys("fileAssets");
export const settingKeys = createKeys("settings");
export const linkedAccountKeys = createKeys("linkedAccounts");
export const userKeys = createKeys("users");
export const templateKeys = createKeys("templates");
export const dataViewKeys = createKeys("dataViews");
export const entityKeys = createKeys("entities");
export const storageAccountKeys = createKeys("storageAccounts");
export const bookingKeys = createKeys("bookings");
export const schoolKeys = createKeys("schools");
export const notificationKeys = createKeys("notifications");
export const staffProfileKeys = createKeys("staffProfiles");
export const crmEntityColumnMapKeys = createKeys("crmEntityColumnMappings");
export const crmDataFieldKeys = createKeys("crmDataFields");
export const crmSourceOptionKeys = createKeys("crmSourceOptions");

export type InvalidateFn = (queryClient: QueryClient) => void;
